import React from 'react';
import { Box } from '@mui/material';
import { EntityType } from '@/components/entities/entityType';
import { ExecutionStep, ExecutionStepResult } from '@/interfaces/pipelineExecution.interface';
import StepViewer from '../pipelineView/stepViewer';
import { RightPanelContext } from './types';

interface SingleEntityPanelProps {
  rightPanelContext: RightPanelContext;
  executingStepId?: string | null;
  stepExecutionResponse?: ExecutionStepResult | null;
  onClearStepExecutionResponse?: () => void;
  onExecuteAction?: (
    step: ExecutionStep,
    options?: { inputOverride?: any; reingest?: boolean; suppressEvents?: boolean },
  ) => void;
  onChange?: () => void;
}

export const SingleEntityPanel: React.FC<SingleEntityPanelProps> = ({
  rightPanelContext,
  executingStepId,
  stepExecutionResponse,
  onClearStepExecutionResponse,
  onExecuteAction,
  onChange,
}) => {
  const { entityType, entityId, entityDefId, entityName, entityData } = rightPanelContext;

  const defId =
    entityDefId ||
    entityData?.defId ||
    entityData?.dataSourceDefId ||
    entityData?.agentDefId ||
    entityData?.userAppDefId ||
    entityId ||
    '';

  const instId = entityId || entityData?.id || '';
  const name = entityName || entityData?.name || instId;
  const isActive = entityData?.active !== false;

  const entityStep: ExecutionStep = {
    id: instId,
    name: name,
    entityType: entityType as EntityType,
    entityDefId: defId,
    entityId: instId,
    entityName: name,
    entityDefName: entityData?.defName || name,
    status: isActive ? 'completed' : 'pending',
    upstreamEntities: [],
  };

  return (
    <Box
      sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column', height: '100%', minHeight: 0, overflow: 'hidden' }}
    >
      <StepViewer
        step={entityStep}
        onExecuteStep={onExecuteAction || (() => {})}
        onRestartFromPoint={() => {}}
        isExecuting={executingStepId === instId}
        stepExecutionResponse={stepExecutionResponse}
        onClearStepExecutionResponse={onClearStepExecutionResponse}
        onChange={onChange}
      />
    </Box>
  );
};

export default SingleEntityPanel;
